import React, { useEffect, useState } from "react";
import axios from "axios";
import "../App.css";
import "./userHistory.css";
import { resolveShortId } from "../utils/userIdentity";
import {
  ChakraProvider,
  IconButton,
  SkeletonText,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
} from "@chakra-ui/react";
import { useToast } from "@chakra-ui/react";
import deleteDTC from "../assets/deleteDTC.svg";

const SERVER_URL =
  process.env.NODE_ENV === "development" ? "http://localhost:5000/" : "/api/";
const HISTORY_SERVER_URL = SERVER_URL + "history";
const CONVERSATIONS_URL = SERVER_URL + "history/conversations";
const USER_LOGS_SERVER_URL = SERVER_URL + "user-logs";

export default function UserHistory(props) {
  const OverlayTwo = () => (
    <ModalOverlay
      bg="blackAlpha.300"
      backdropFilter="blur(10px) hue-rotate(90deg)"
    />
  );

  const [selectedChat, setSelectedChat] = useState([]);
  const [isloading, setisloading] = useState(true);
  const [userHistory, setUserHistory] = useState({});
  const [today, setToday] = useState([]);
  const [yesterday, setYesterday] = useState([]);
  const [last7Days, setLast7Days] = useState([]);
  const [last30Days, setLast30Days] = useState([]);
  const [childData, setChildData] = useState("");
  const [overlay, setOverlay] = React.useState(<OverlayTwo />);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast({ position: "top-right" });
  const [error, setError] = useState(null); // Handle error state
  const [chatToDelete, setChatToDelete] = useState(null); // Track chat to delete

  // Helper function to get the earliest message by timestamp
  const getEarliestMessage = (messages) => {
    if (!messages || messages.length === 0) return null;

    return messages.reduce((earliest, current) => {
      const earliestTime = new Date(earliest.Timestamp);
      const currentTime = new Date(current.Timestamp);
      return currentTime < earliestTime ? current : earliest;
    });
  };

  const removeHistory = (chatId) => {
    setUserHistory((prevHistory) => {
      const updatedHistory = { ...prevHistory };

      // Remove the entry with the matching chatId
      if (updatedHistory[chatId]) {
        delete updatedHistory[chatId];
      }
      groupingFunction(updatedHistory);
      return updatedHistory; // Return the updated history object
    });
  };

  const handleSubmit = async () => {
    if (!chatToDelete) {
      return;
    }
    const deleteChatPromise = new Promise(async (resolve, reject) => {
      const response = await axios.delete(HISTORY_SERVER_URL, {
        params: {
          ChatId: chatToDelete,
          userEmail: localStorage.getItem('userinfo')
        },
      });
      if (response.data.valid) {
        removeHistory(chatToDelete);
        props.handleNewChat();
        resolve("Chat Deleted successfully");
      } else {
        reject("Failed to Delete Chat history!");
        console.error("Failed to Delete Chat history:", response.data.message);
      }
    });
    toast.promise(deleteChatPromise, {
      loading: {
        title: props.translate("Deleting Chat"),
        description: props.translate("Please wait") + "...",
        duration: 1000,
        isClosable: true,
      },
      success: {
        description: props.translate("Chat Deleted successfully!"),
        duration: 1000,
        isClosable: true,
      },
      error: {
        description: props.translate("Something went wrong. Please try again."),
        duration: 1000,
        isClosable: true,
      },
    });
    try {
      await deleteChatPromise;
      onClose(); // Close modal
      setChatToDelete(null); // Clear the chat to delete
    } catch (error) {
      setError(error); // Set error state if submission fails
    }
  };
  // Method in the child to be called from the parent
  const childMethod = (data) => {
    setChildData(data);
    setUserHistory((prevHistory) => {
      const updatedHistory = prevHistory[data.ChatId]
        ? {
          ...prevHistory,
          [data.ChatId]: [...prevHistory[data.ChatId], data],
        }
        : {
          ...prevHistory,
          [data.ChatId]: [data],
        };

      // Call grouping function with the updated history
      groupingFunction(updatedHistory, data);

      return updatedHistory; // Make sure to return the updated state
    });
  };

  const setChat = () => {
    setSelectedChat([]);
  };
  useEffect(() => {
    if (props.setChildFunc) {
      // Pass the childMethod to the parent
      props.setChildFunc(() => childMethod); // Use a stable function reference
    }
  }, [props.setChildFunc]);

  useEffect(() => {
    if (props.setRemoveChatFunc) {
      // Pass the childMethod to the parent
      props.setRemoveChatFunc(() => setChat); // Use a stable function reference
    }
  }, [props.setRemoveChatFunc]);

  useEffect(() => { }, [today]);

  const getDaysDifference = (date) => {
    const now = new Date();

    // Reset the time part (hours, minutes, seconds, and milliseconds) for both dates
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const targetDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );

    // Calculate the difference in days between the two dates
    return Math.floor((today - targetDate) / (1000 * 60 * 60 * 24)); // Convert milliseconds to days
  };

  const groupingFunction = (data, newChat) => {
    setToday([]);
    setYesterday([]);
    setLast7Days([]);
    setLast30Days([]);
    const sortedData = Object.entries(data)
      .sort(([, timestampsA], [, timestampsB]) => {
        // Get the newest (last) timestamp from each group
        // After backend fix, messages are in ASC order (oldest first, newest last)
        const getNewestTimestamp = (timestamps) => {
          if (!timestamps || timestamps.length === 0) return new Date(0);
          // Get the last message (newest after backend ASC sort)
          return new Date(timestamps[timestamps.length - 1].Timestamp);
        };

        const lastTimestampA = getNewestTimestamp(timestampsA);
        const lastTimestampB = getNewestTimestamp(timestampsB);

        // Sort in descending order by the latest timestamp (most recent conversations first)
        return lastTimestampB - lastTimestampA;
      })
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {});
    const categorizedData = {
      today: [],
      yesterday: [],
      last7Days: [],
      last30Days: [],
    };
    Object.entries(sortedData).forEach(([key, timestamps]) => {
      // Get the latest timestamp in each group
      const lastTimestamp = new Date(
        timestamps[timestamps.length - 1].Timestamp
      );

      // Calculate days difference
      const daysDifference = getDaysDifference(lastTimestamp);

      // Categorize the entry based on the days difference
      if (daysDifference === 0) {
        categorizedData.today.push({ [key]: timestamps });
      } else if (daysDifference === 1) {
        categorizedData.yesterday.push({ [key]: timestamps });
      } else if (daysDifference <= 7) {
        categorizedData.last7Days.push({ [key]: timestamps });
      } else if (daysDifference <= 30) {
        categorizedData.last30Days.push({ [key]: timestamps });
      }
    });
    setToday(categorizedData.today);
    setYesterday(categorizedData.yesterday);
    setLast7Days(categorizedData.last7Days);
    setLast30Days(categorizedData.last30Days);
    if (newChat) {
      setSelectedChat(categorizedData.today[0][newChat.ChatId]);
    }
  };

  const fetchUserEmail = async () => {
    try {
      const response = await axios.get("/oauth2/userinfo");

      sessionStorage.setItem("userinfoResponse", JSON.stringify(response.data));

      // Prefer a real email claim (Microsoft) → local part; fall back to the bare `user`
      // short ID (CIAM), never a GUID/opaque value. Keeps history keyed on the same ID
      // the backend derives from the JWT.
      const shortId = resolveShortId(response.data)?.toLowerCase();
      if (shortId) {
        localStorage.setItem("userinfo", shortId);
        await axios.post(USER_LOGS_SERVER_URL, { UserEmail: shortId });
      }
    } catch (err) {
      // Error handled silently
    }
  };

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  // ... (previous useEffects) ...

  const fetchUserHistory = async (pageToFetch = 1) => {
    try {
      if (pageToFetch === 1) setisloading(true);

      if (!localStorage.getItem("userinfo")) {
        await fetchUserEmail();
      }

      // Use lightweight conversations endpoint for sidebar
      const response = await axios.get(CONVERSATIONS_URL, {
        params: {
          userEmail: localStorage.getItem('userinfo'),
          page: pageToFetch,
          limit: 20
        },
      });

      if (response.data.valid && response.data.conversations.length > 0) {
        const conversations = response.data.conversations;
        // Convert to format expected by groupingFunction
        const newData = {};
        conversations.forEach(conv => {
          newData[conv.chat_id] = [{
            ChatId: conv.chat_id,
            UserResponse: conv.title,
            Timestamp: conv.updated_at
          }];
        });

        setUserHistory(prev => {
          const updated = { ...prev, ...newData };
          groupingFunction(updated);
          return updated;
        });
        setisloading(false);
      } else if (response.data.message === "No more conversations found" || response.data.conversations?.length === 0) {
        setHasMore(false);
        setisloading(false);
      } else {
        console.error("Failed to fetch conversations:", response.data.message);
        setisloading(false);
      }
    } catch (error) {
      setisloading(false);
      console.error("Error fetching conversations:", error);
    }
  };

  // Initial load
  useEffect(() => {
    fetchUserHistory(1);
  }, []);

  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    if (bottom && hasMore && !isloading) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchUserHistory(nextPage);
    }
  };

  // ... (rendering logic with onScroll added to history-container or list) ...

  const [loadingConversation, setLoadingConversation] = useState(null);

  const handleClick = async (chatId) => {
    // Fetch full conversation messages when clicked
    try {
      setLoadingConversation(chatId);
      if (props.setIsLoadingConversation) {
        props.setIsLoadingConversation(true); // Show central loader while loading conversation
      }

      const response = await axios.get(`${SERVER_URL}history/conversation/${chatId}`, {
        params: {
          userEmail: localStorage.getItem('userinfo')
        }
      });

      if (response.data.valid && response.data.messages.length > 0) {
        const messages = response.data.messages;
        setSelectedChat(messages);
        props.openHistory(messages);

        // Set conversation_id from ChatId
        const lastEntry = messages[messages.length - 1];
        if (lastEntry?.ChatId) {
          props.setConversationId(lastEntry.ChatId);
        }
      } else {
        console.error("Failed to load conversation:", response.data.message);
      }
    } catch (error) {
      console.error("Error loading conversation:", error);
    } finally {
      setLoadingConversation(null);
      if (props.setIsLoadingConversation) {
        props.setIsLoadingConversation(false); // Hide central loader after loading
      }
    }
  };

  return (
    <div className="history-container" onScroll={handleScroll}>
      {!isloading && (
        <>
          <ChakraProvider resetCSS={false}>
            <Modal isCentered isOpen={isOpen} onClose={() => { onClose(); setChatToDelete(null); }}>
              {overlay}
              <ModalContent>
                <ModalCloseButton />
                <ModalBody>
                  <h2 className="feedback-title">
                    {props.translate(
                      "Are you sure you want to delete this chat?"
                    )}
                  </h2>
                </ModalBody>
                <ModalFooter>
                  <Button onClick={() => { onClose(); setChatToDelete(null); }} mr={3}>
                    {props.translate("Close")}
                  </Button>
                  <Button colorScheme="red" onClick={() => handleSubmit()}>
                    {props.translate("Delete")}
                  </Button>
                </ModalFooter>
              </ModalContent>
            </Modal>
          </ChakraProvider>
          {today.length > 0 && (
            <>
              <h2 className="history-heading">{props.translate("Today")}</h2>
              <ul className="history-list">
                {today.map(
                  (item, index) =>
                    item &&
                    Object.keys(item).map((key) => {
                      const earliestMessage = getEarliestMessage(item[key]);
                      const isLoading = loadingConversation === key;
                      return (
                        <li
                          className={`${selectedChat.length &&
                            selectedChat[0]["ChatId"] === key
                            ? "selected"
                            : ""
                            } ${isLoading ? "loading" : ""}`}
                          key={key}
                          onClick={() => handleClick(key)}
                        >
                          <span className="chat-text">
                            {isLoading ? "Loading..." : (earliestMessage ? earliestMessage.UserResponse : "")}
                          </span>
                          <div className="chatOptions">
                            <ChakraProvider resetCSS={false}>
                              <IconButton
                                className="delete-button"
                                aria-label="Delete"
                                variant="ghost"
                                size="sm"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setChatToDelete(key);
                                  setOverlay(<OverlayTwo />);
                                  onOpen();
                                }}
                              >
                                <img
                                  className="customDeleteIcon"
                                  src={deleteDTC}
                                  alt="deleteIcon"
                                ></img>
                              </IconButton>
                            </ChakraProvider>
                          </div>
                        </li>
                      );
                    })
                )}
              </ul>
            </>
          )}
          {yesterday.length > 0 && (
            <>
              <h2 className="history-heading">
                {props.translate("Yesterday")}
              </h2>
              <ul className="history-list">
                {yesterday.map(
                  (item, index) =>
                    item &&
                    Object.keys(item).map((key) => {
                      const earliestMessage = getEarliestMessage(item[key]);
                      const isLoading = loadingConversation === key;
                      return (
                        <li
                          className={`${selectedChat.length &&
                            selectedChat[0]["ChatId"] === key
                            ? "selected"
                            : ""
                            } ${isLoading ? "loading" : ""}`}
                          key={key}
                          onClick={() => handleClick(key)}
                        >
                          <span className="chat-text">
                            {isLoading ? "Loading..." : (earliestMessage ? earliestMessage.UserResponse : "")}
                          </span>
                          <div className="chatOptions">
                            <ChakraProvider resetCSS={false}>
                              <IconButton
                                className="delete-button"
                                aria-label="Delete"
                                variant="ghost"
                                size="sm"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setChatToDelete(key);
                                  setOverlay(<OverlayTwo />);
                                  onOpen();
                                }}
                              >
                                <img
                                  className="customDeleteIcon"
                                  src={deleteDTC}
                                  alt="deleteIcon"
                                ></img>
                              </IconButton>
                            </ChakraProvider>
                          </div>
                        </li>
                      );
                    })
                )}
              </ul>
            </>
          )}
          {last7Days.length > 0 && (
            <>
              <h2 className="history-heading">
                {props.translate("Last 7 Days")}
              </h2>
              <ul className="history-list">
                {last7Days.map(
                  (item, index) =>
                    item &&
                    Object.keys(item).map((key) => {
                      const earliestMessage = getEarliestMessage(item[key]);
                      const isLoading = loadingConversation === key;
                      return (
                        <li
                          className={`${selectedChat.length &&
                            selectedChat[0]["ChatId"] === key
                            ? "selected"
                            : ""
                            } ${isLoading ? "loading" : ""}`}
                          key={key}
                          onClick={() => handleClick(key)}
                        >
                          <span className="chat-text">
                            {isLoading ? "Loading..." : (earliestMessage ? earliestMessage.UserResponse : "")}
                          </span>
                          <div className="chatOptions">
                            <ChakraProvider resetCSS={false}>
                              <IconButton
                                className="delete-button"
                                aria-label="Delete"
                                variant="ghost"
                                size="sm"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setChatToDelete(key);
                                  setOverlay(<OverlayTwo />);
                                  onOpen();
                                }}
                              >
                                <img
                                  className="customDeleteIcon"
                                  src={deleteDTC}
                                  alt="deleteIcon"
                                ></img>
                              </IconButton>
                            </ChakraProvider>
                          </div>
                        </li>
                      );
                    })
                )}
              </ul>
            </>
          )}
          {last30Days.length > 0 && (
            <>
              <h2 className="history-heading">
                {props.translate("Last 30 Days")}
              </h2>
              <ul className="history-list">
                {last30Days.map(
                  (item, index) =>
                    item &&
                    Object.keys(item).map((key) => {
                      const earliestMessage = getEarliestMessage(item[key]);
                      const isLoading = loadingConversation === key;
                      return (
                        <li
                          className={`${selectedChat.length &&
                            selectedChat[0]["ChatId"] === key
                            ? "selected"
                            : ""
                            } ${isLoading ? "loading" : ""}`}
                          key={key}
                          onClick={() => handleClick(key)}
                        >
                          <span className="chat-text">
                            {isLoading ? "Loading..." : (earliestMessage ? earliestMessage.UserResponse : "")}
                          </span>
                          <div className="chatOptions">
                            <ChakraProvider resetCSS={false}>
                              <IconButton
                                className="delete-button"
                                aria-label="Delete"
                                variant="ghost"
                                size="sm"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setChatToDelete(key);
                                  setOverlay(<OverlayTwo />);
                                  onOpen();
                                }}
                              >
                                <img
                                  className="customDeleteIcon"
                                  src={deleteDTC}
                                  alt="deleteIcon"
                                ></img>
                              </IconButton>
                            </ChakraProvider>
                          </div>
                        </li>
                      );
                    })
                )}
              </ul>
            </>
          )}
        </>
      )}
      {isloading && (
        <ChakraProvider resetCSS={false}>
          <ul className="history-list" style={{ paddingInline: "8px" }}>
            <SkeletonText noOfLines={3} skeletonHeight="3" />
          </ul>
        </ChakraProvider>
      )}
    </div>
  );
}